const ACCESS_COPY = {
  guest: {
    eyebrow: 'Guest catalog access',
    title: 'Catalog and pricing unlocked',
    description: 'A free account browses the full catalog and pricing. Wholesale approval is required to purchase.',
    showMembershipLink: true,
  },
  pending: {
    eyebrow: 'Wholesale application pending',
    title: 'Catalog and pricing unlocked',
    description: 'Your wholesale application is pending review. You can browse the full catalog and pricing while you wait.',
    showMembershipLink: false,
  },
  approved: {
    eyebrow: 'Member ordering portal',
    title: 'Wholesale account approved',
    description: 'Build your cart and follow existing orders here. Checkout availability is confirmed with your cart quote.',
    showMembershipLink: false,
  },
  rejected: {
    eyebrow: 'Wholesale application not approved',
    title: 'Catalog and pricing unlocked',
    description: 'Your wholesale application was not approved. You can still browse the full catalog and pricing.',
    showMembershipLink: false,
  },
  admin: {
    eyebrow: 'Administrator storefront view',
    title: 'Administrator access',
    description: 'You are viewing the storefront with administrator access. Customer ordering status does not change this preview.',
    showMembershipLink: false,
  },
};

export function catalogAccess(user) {
  if (user?.role === 'admin') return { status: 'admin', ...ACCESS_COPY.admin };
  if (!user || user.is_guest || user.status === 'guest') return { status: 'guest', ...ACCESS_COPY.guest };

  const status = ['pending', 'approved', 'rejected'].includes(user.status) ? user.status : 'pending';
  return { status, ...ACCESS_COPY[status] };
}
